import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupVendor } from "src/components/Shared/NewForms/NFLookupVendor";
import { NFLookupDistributionOfLandedCosts } from "src/components/Shared/NewForms/NFLookupDistributionOfLandedCosts";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { useTranslation } from "react-i18next";

export const ImportsDetailAdditionalDocuments = () => {
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"additionalDocuments"}>
                <NFLookupDistributionOfLandedCosts
                    fieldName={"distributionOfLandedCosts"}
                    title={t("DistributionOfLandedCosts")}
                />
                <NFLookupVendor
                    fieldName={"vendorInvoiceId"}
                    title={t("VendorInvoice")}
                />
                <NFLookupCurrency
                    title={t("Currency")}
                    fieldName={"currencyId"}
                />
                <NFIntInput
                    fieldName={"amount"}
                    title={t("Amount")}
                    width={100}
                />
                <NFIntInput fieldName={"vat"} title={t("Vat")} width={100} />
                <NFIntInput
                    fieldName={"amount"}
                    title={t("Amount(r/c)")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"vat"}
                    title={t("Vat(r/c)")}
                    width={100}
                />
            </NFormTable>
        </>
    );
};
